/**
 * -----------------------------------------------------------------------------
 * Project  : ReelConsensus app - Frontend Page: CreatePoll
 * File     : CreatePoll.js
 * Author   : Zachary Dry
 * Created  : 2025-09-18
 * Updated  : 2025-09-19
 * Version  : 1.0
 * License: Proprietary (Company Confidential)
 * -----------------------------------------------------------------------------
 * Description:
 *   React page component rendering the CreatePoll view and coordinating data fetching.
 *   Exports: CreatePoll
 *   
 *
 * Dependencies:
 *   - ../components/polls/PollForm
 *   - ../context/AuthContext
 *   - @mui/material
 *   - react
 *   - react-router-dom
 *
 * Usage:
 *   Use in Router: <Route path="/createpoll" element={<CreatePoll />} />
 * -----------------------------------------------------------------------------
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import PollForm from '../components/polls/PollForm';
import { useAuth } from '../context/AuthContext';

const CreatePoll = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return <Typography>You must be logged in to create polls.</Typography>;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Create a Poll</Typography>
      <PollForm
        onSuccess={(poll) => navigate(`/results/${poll.id}`)}
        initialMovies={(function(){
          try {
            const raw = localStorage.getItem('prefillPollMovies');
            if (!raw) return [];
            const val = JSON.parse(raw);
            localStorage.removeItem('prefillPollMovies');
            return Array.isArray(val) ? val : [];
          } catch (_) { return []; }
        })()}
      />
    </Box>
  );
};

export default CreatePoll;


